import * as XLSX from "xlsx";
import { onlyDigits } from "@/helpers/cpf";

export type ParsedImportRow = {
  row: number;
  document: string;
  name?: string;
  phone?: string;
  email?: string;
};

export const IMPORT_TEMPLATE_HEADERS = [
  "Documento",
  "Nome Completo",
  "Telefone",
  "Email",
] as const;

const MAX_ROWS = 500;

function cellToString(value: unknown): string {
  if (value == null) {
    return "";
  }
  if (typeof value === "number") {
    // Avoid scientific notation for CPF-like numbers from Excel.
    return String(Math.trunc(value));
  }
  return String(value).trim();
}

export function downloadClientsImportTemplate(): void {
  const worksheet = XLSX.utils.aoa_to_sheet([
    [...IMPORT_TEMPLATE_HEADERS],
    ["00000000000", "Nome Exemplo", "11999999999", "email@exemplo.com"],
  ]);
  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Clientes");
  XLSX.writeFile(workbook, "modelo-importacao-clientes.csv");
}

export async function parseClientsImportFile(
  file: File,
  firstRowIsHeader: boolean,
): Promise<ParsedImportRow[]> {
  const data = await file.arrayBuffer();
  const workbook = XLSX.read(data, { type: "array" });
  const firstSheetName = workbook.SheetNames[0];
  if (!firstSheetName) {
    return [];
  }

  const sheet = workbook.Sheets[firstSheetName];
  const rows = XLSX.utils.sheet_to_json(sheet, {
    header: 1,
    defval: "",
    raw: false,
    blankrows: false,
  }) as Array<Array<string | number | null | undefined>>;

  const startIndex = firstRowIsHeader ? 1 : 0;
  const parsed: ParsedImportRow[] = [];

  for (let i = startIndex; i < rows.length; i += 1) {
    const row = rows[i] || [];
    const document = onlyDigits(cellToString(row[0]));
    const name = cellToString(row[1]) || undefined;
    const phone = onlyDigits(cellToString(row[2])) || undefined;
    const email = cellToString(row[3]) || undefined;

    if (!document && !name && !phone && !email) {
      continue;
    }

    parsed.push({
      row: i + 1,
      document,
      name,
      phone,
      email,
    });

    if (parsed.length >= MAX_ROWS) {
      break;
    }
  }

  return parsed;
}
